import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../contexts/AuthContext';

const SidebarContainer = styled.div`
  width: 250px;
  background-color: ${({ theme }) => theme.colors.tertiary};
  color: white;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  min-height: 100vh;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const Logo = styled.h2`
  margin-bottom: 2rem;
  font-size: 1.2rem;
`;

const NavList = styled.ul`
  flex: 1;
`;

const NavItem = styled.li`
  margin-bottom: 0.5rem;
`;

const StyledLink = styled(Link)`
  display: block;
  padding: 0.8rem;
  border-radius: 4px;
  background-color: ${({ $isActive }) => ($isActive ? 'rgba(255,255,255,0.2)' : 'transparent')};
  &:hover {
    background-color: rgba(255,255,255,0.1);
  }
`;

const LogoutButton = styled.button`
  background: transparent;
  border: 1px solid white;
  color: white;
  padding: 0.5rem;
  border-radius: 4px;
  margin-top: auto;
  &:hover {
    background: white;
    color: ${({ theme }) => theme.colors.tertiary};
  }
`;

const AdminSidebar = () => {
  const location = useLocation();
  const { logout, user } = useAuth();

  const links = [
    { name: 'Dashboard', path: '/admin' },
    { name: 'Home Page', path: '/admin/home' },
    { name: 'About Us', path: '/admin/about' },
    { name: 'News & Media', path: '/admin/news' },
    { name: 'Workshops', path: '/admin/workshops' },
    { name: 'Outreach', path: '/admin/outreach' },
    { name: 'Team', path: '/admin/team' },
    { name: 'Gallery', path: '/admin/gallery' },
    { name: 'Donate', path: '/admin/donate' },
    { name: 'Contact Info', path: '/admin/contact' },
  ];

  if (user?.role === 'superAdmin') {
    links.push({ name: 'Users', path: '/admin/users' });
  }

  return (
    <SidebarContainer>
      <Logo>26MM CMS</Logo>
      <NavList>
        {links.map((link) => (
          <NavItem key={link.name}>
            <StyledLink 
              to={link.path} 
              $isActive={location.pathname === link.path || (link.path !== '/admin' && location.pathname.startsWith(link.path))}
            >
              {link.name}
            </StyledLink>
          </NavItem>
        ))}
      </NavList>
      <LogoutButton onClick={logout}>Logout</LogoutButton>
    </SidebarContainer>
  );
};

export default AdminSidebar;
